/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Follow_Following_ListInputs */

const en_follow_following_list = /** @type {(inputs: Follow_Following_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Following`)
};

const es_follow_following_list = /** @type {(inputs: Follow_Following_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siguiendo`)
};

const fr_follow_following_list = /** @type {(inputs: Follow_Following_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnements`)
};

const de_follow_following_list = /** @type {(inputs: Follow_Following_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folge ich`)
};

const id_follow_following_list = /** @type {(inputs: Follow_Following_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diikuti`)
};

/** @type {(inputs: Follow_Following_ListInputs) => LocalizedString} */
const ja_follow_following_list = en_follow_following_list;

/** @type {(inputs: Follow_Following_ListInputs) => LocalizedString} */
const zh_follow_following_list = en_follow_following_list;

/** @type {(inputs: Follow_Following_ListInputs) => LocalizedString} */
const ar_follow_following_list = en_follow_following_list;

/** @type {(inputs: Follow_Following_ListInputs) => LocalizedString} */
const it_follow_following_list = en_follow_following_list;

/** @type {(inputs: Follow_Following_ListInputs) => LocalizedString} */
const ru_follow_following_list = en_follow_following_list;

/** @type {(inputs: Follow_Following_ListInputs) => LocalizedString} */
const pt_follow_following_list = en_follow_following_list;

/** @type {(inputs: Follow_Following_ListInputs) => LocalizedString} */
const ko_follow_following_list = en_follow_following_list;

/**
* | output |
* | --- |
* | "Following" |
*
* @param {Follow_Following_ListInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const follow_following_list = /** @type {((inputs?: Follow_Following_ListInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Follow_Following_ListInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_follow_following_list(inputs)
	if (locale === "es") return es_follow_following_list(inputs)
	if (locale === "fr") return fr_follow_following_list(inputs)
	if (locale === "de") return de_follow_following_list(inputs)
	if (locale === "ja") return ja_follow_following_list(inputs)
	if (locale === "zh") return zh_follow_following_list(inputs)
	if (locale === "ar") return ar_follow_following_list(inputs)
	if (locale === "id") return id_follow_following_list(inputs)
	if (locale === "it") return it_follow_following_list(inputs)
	if (locale === "ru") return ru_follow_following_list(inputs)
	if (locale === "pt") return pt_follow_following_list(inputs)
	return ko_follow_following_list(inputs)
});